<template>
  <div class="sign-in-sign-up-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SignInSignUpContent'
}
</script>

<style scoped lang="scss">
.sign-in-sign-up-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;

  ::v-deep .sing-in-form {
    width: $sign-in-form-width;

    .form-group {
      margin-bottom: 32px;

      // &.is-invalid {
      //   margin-bottom: 14px;
      // }
    }

    .requirements-container {
      text-align: left;
      font-size: 18px;
      color: $fontColorBase;

      ul {
        padding-left: 30px;
      }

      .password-title {
        font-weight: 500;
        margin-bottom: 5px;
      }
    }

    .link {
      text-decoration: none;
      border-bottom-color: $fontColorAccent;
      font-weight: 500;
      letter-spacing: 0;
    }

    .sign-with {
      margin: 43px 0;
      display: flex;
      justify-content: center;
      width: 100%;
      position: relative;
      text-align: center;
      border-bottom: 1px solid $fontColor2;

      .text {
        position: absolute;
        top: -14px;
        background: #fff;
        padding: 0 10px;
        font-size: 18px;
        font-weight: 500;
        color: $fontColorBase;
      }
    }

    .input-label {
      color: $fontColorBase;
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 13px;
    }

    .sing-up-input {
      height: $sign-in-input-height;
      font-size: $sign-in-input-font-size;
      border-radius: $sign-in-input-border-radius;
      padding-left: $sign-in-input-padding-left;

      &:not(:disabled, [readonly]) {
        background-color: $sign-in-input-background-color;
      }

      &::placeholder {
        font-size: $sign-in-input-font-size;
        font-weight: 500;
        color: $fontColor2;
      }

      &.is-invalid {
        background-image: none;
      }
    }

    .sign-up-checkbox {
      label {
        font-size: 16px;
        font-weight: 500;
        line-height: 18.38px;
        text-align: left;

        &::before {
          top: 1px;
        }

        &::after {
          top: 1px;
        }
      }
    }

    .invalid-feedback {
      width: auto;
      margin-top: 2px;
      font-size: 14px;
      line-height: 16px;
    }

    .confirm-button {
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .btn.btn-light {
      border: 1px solid $fontColorAccent;
    }

    img {
      width: fit-content;
    }
  }

  ::v-deep .button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: $sign-in-form-width;
    margin-top: 30px;
    height: $sign-in-button-height;
    border-radius: 10px;
    font-family: $font-family-sans-serif;
    font-size: 20px;
    font-weight: 700;
    text-transform: initial;
  }

  ::v-deep .sign-in-title {
    margin-bottom: 32px;
    font-size: 30px;
    line-height: 48px;
    font-weight: 700;
    text-align: center;
  }

  ::v-deep .input-group-append {
    height: 52px;

    .input-group-text {
      background-color: #cacedb;
      color: #3d5170;
      font-weight: 500;
      font-size: 18px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
}
</style>
